import { createAction } from '@reduxjs/toolkit'

import {
  IPrePurchaseAnalytics,
  IPrePurchaseBrandConnectAnalytics,
  PrePurchaseAnalyticsActionTypes,
  PrePurchaseAnalyticsType,
} from './types'

export const fetchPrePurchaseAnalytics = (
  identityId: number,
  submissionId: number,
  prePurchaseAnalyticsType: PrePurchaseAnalyticsType,
) => ({
  type: PrePurchaseAnalyticsActionTypes.FETCH_REQUEST,
  payload: {
    submissionId,
    identityId,
    prePurchaseAnalyticsType,
  },
})

export const fetchPrePurchaseAnalyticsSuccess = (
  identityId: number,
  prePurchaseAnalyticsType: PrePurchaseAnalyticsType,
  prePurchaseAnalytics: IPrePurchaseAnalytics,
) => ({
  type: PrePurchaseAnalyticsActionTypes.FETCH_SUCCESS,
  payload: {
    identityId,
    prePurchaseAnalyticsType,
    prePurchaseAnalytics,
  },
})

export const fetchPrePurchaseAnalyticsError = (error: any) => ({
  type: PrePurchaseAnalyticsActionTypes.FETCH_ERROR,
  payload: error,
})

export const fetchPrePurchaseBrandConnectAnalyticsSuccess = createAction(
  PrePurchaseAnalyticsActionTypes.FETCH_BRAND_CONNECT_SUCCESS,
  (identityId: number, prePurchaseAnalytic: IPrePurchaseBrandConnectAnalytics[]) => ({
    payload: { identityId, prePurchaseAnalytic },
  }),
)
